import React from "react";
import { IovationScripts } from "tsi-common-react/src/components/IovationScripts/index";

import { Context, templates } from "@reactivated";

import { PageSkeleton } from "../components/PageSkeleton";
import { Template as WriteReview } from "./WriteReviewTemplate";

// Exported for the vitest pin: IovationScripts renders null on the server, so
// only a client render can prove the page still mounts it -- and rendering the
// whole Template would drag in PageSkeleton's full GlobalChrome context.
export const WriteReviewPageScripts = (props: {
    iovationUrl: string;
}): React.JSX.Element => {
    const chrome = React.useContext(Context).chrome;
    return (
        <IovationScripts
            iovationUrl={props.iovationUrl}
            staticBase={chrome.static_base}
        />
    );
};

// Mutable reactivated props (not Immutable<>): PageSkeleton composes the in-tree
// SiteHeader chain, which is typed with mutable reactivated props.
export const Template = (
    props: templates.WriteReviewPageDocumentTemplate,
): React.JSX.Element => {
    return (
        <PageSkeleton pageChrome={props.page_chrome}>
            <div className="customer-review__header customer-review__header--write-review">
                <WriteReview
                    brand_id={props.brand_id}
                    return_url={props.return_url}
                    products_data={props.products_data}
                    review_template_data={props.review_template_data}
                />
            </div>
            <WriteReviewPageScripts iovationUrl={props.iovation_url} />
        </PageSkeleton>
    );
};
